<template>
  <section>
    <div id="method-container">
      <div id="method-text-box">
        <h2 id="headline">Our <span class="blue">Statement and Methodology</span></h2>
        <div id="method-body-text">
          <span class="red">Pickswise stands against all forms of online abuse and trolling.</span> 
          The purpose of this data is to highlight the level of abuse directed at sports professionals and to 
          encourage social media companies to do more to combat the practice.<br><br> 
          The data was collected directly from Twitter from the past 12 months (June 2020 – June 2021). 
          Messages containing words, phrases and hashtags that were known abusive terms were logged against each 
          player and the respective sport they play/ played in.<br><br> 
          More than 500,000 abusive messages were analysed across 75 current or former athletes.
          Pickswise is the #1 home of free 
          <a href="https://www.pickswise.com/nfl/picks/">NFL picks</a>,
          <a href="https://www.pickswise.com/nfl/predictions/">predictions</a> and
          <a href="https://www.pickswise.com/nfl/odds/">odds</a>. 
          Find the latest lines and opinions for every game.
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-height: 300px;
  background-color: $blue;
  color: $white;
  padding-bottom: 50px;
}

#method-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
}

#method-text-box {
  max-width: 800px;
  padding: 20px;
  text-align: left;
}

#headline {
  font-size: 30px;
  padding-top: 40px;
}

#method-body-text {
  font-size: 16px;
  color: $text-grey;
  padding-top: 20px;
}

.blue {
  color: $text-blue;
}

.red {
  color: $red;
}
</style>